export default function FooterBar() {
  return (
    <footer className="py-2 px-4 flex items-center justify-between text-xs border-t bg-[#f0f2f5] dark:bg-[#111b21] text-slate-500 dark:text-slate-500 border-black/[0.06] dark:border-white/[0.06]">
      <span>Centro de Agentes Flux</span>
      <span>© {new Date().getFullYear()}</span>
    </footer>
  );
}
